import { logInfo, logError } from '../core/logger'
import axiosService from './axios'
import { generateGUID } from '~/core/utils'
import API_URLS from '~/core/api-urls'

const REQ_TIMEOUT = 20000
export const ERR_KEY = '@@@ERR'

const getEndpointsExpectedToFail = () => [
  API_URLS.CALENDAR.STATUS
]

// eslint-disable-next-line no-unused-vars
const composeOptions = (originalOptions, reqId) => {
  const JSON_METHODS = ['GET', 'PATCH', 'POST', 'PUT', 'DELETE']
  const originalHeaders = originalOptions.headers || {}

  const options = {
    ...originalOptions,
    headers: {
      ...originalHeaders
      // 'Request-ID': generateGUID()
    }
  }

  if (JSON_METHODS.includes(options.method)) {
    options.headers['Content-Type'] = 'application/json'
  }

  return options
}

const getErrorResponse = ({ code, response }) => {
  if (code === 'ECONNABORTED') {
    return {
      [ERR_KEY]: true,
      type: 'timeout',
      message: 'Server timeout'
    }
  }

  if (response) {
    const { data } = response

    return {
      [ERR_KEY]: true,
      args: data?.arguments,
      type: data?.messageKey || 'status',
      message: data?.message || response.status,
      status: response.status
    }
  }

  return {
    [ERR_KEY]: true,
    type: 'unknown',
    message: 'Unknown'
  }
}

const isErrorResponse = res => res[ERR_KEY]

const request = async (url, originalOptions) => {
  const reqId = generateGUID().replace(/-/g, '')
  const options = composeOptions(originalOptions, reqId)
  const data = {
    url,
    ...options,
    timeout: REQ_TIMEOUT
  }

  logInfo(
    {
      __filename,
      reqId,
      url,
      options
    },
    `Request sent to ${url}`
  )

  try {
    const response = await axiosService.axios(data)

    logInfo(
      { __filename, reqId, url },
      `Success response for ${url}`
    )

    return response.data
  } catch (err) {
    const errorResponse = getErrorResponse(err)
    const logMethod = getEndpointsExpectedToFail().includes(url)
      ? logInfo
      : logError

    logMethod(
      { error: err, __filename, errorResponse, reqId, url },
      `Error response for ${url}`
    )

    return errorResponse
  }
}

const get = (url, options) => request(url, { ...options, method: 'GET' })

const del = (url, data = {}) =>
  request(url, {
    method: 'DELETE',
    data: JSON.stringify(data)
  })

const head = url => request(url, { method: 'HEAD' })

const patch = (url, data = {}) =>
  request(url, {
    method: 'PATCH',
    data: JSON.stringify(data)
  })

const post = (url, data = {}) =>
  request(url, {
    method: 'POST',
    data: JSON.stringify(data)
  })

const put = (url, data) =>
  request(url, {
    method: 'PUT',
    data: JSON.stringify(data)
  })

export default {
  get,
  patch,
  post,
  put,
  del,
  head,
  isErrorResponse
}
